import React from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File

import { IMAGE_UPLOADS } from '../../ws/constants';

const defaultButtons = [
    ['undo', 'redo'],
    ['font', 'fontSize', 'formatBlock'],
    ['fontColor', 'hiliteColor', 'textStyle'],
    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
    ['removeFormat'],
    ['outdent', 'indent'],
    ['align', 'horizontalRule', 'list', 'lineHeight'],
    ['table', 'link', 'image', 'video'],
    ['fullScreen', 'showBlocks', 'codeView'],
    ['preview', 'print'],
];

export const Editor = (props) => {
	return ( 
        <SunEditor
            setContents={props.value}
            lang="pt_br"
            setOptions={{
                buttonList: defaultButtons,
                charCounter: true,
                charCounterLabel: "Número de caracteres:",
                imageUploadUrl: IMAGE_UPLOADS,
                ...props.options
            }}
            {...props}
        />
    );
}